import { Table } from 'antd';
import { ORDER_TYPE_CONST } from 'constants/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const OrderSelected = ({ orderSelected }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: 'Order No',
      dataIndex: 'orderNumber',
      key: 'orderNumber',
      render: (d) => (
        <div className="pl-2.5">
          <span className="text-[#EB5757] text-sm">#{d}</span>
        </div>
      ),
      width: 500,
    },
    {
      title: 'Order Type',
      dataIndex: 'orderType',
      key: 'orderType',
      render: (d, rc) => (
        <p>{t(ORDER_TYPE_CONST[rc?.orderType]?.text || '')}</p>
      ),
    },
  ];

  return (
    <TableProductSelectedStyles>
      <Table
        columns={columns}
        dataSource={orderSelected}
        rowKey="id"
        pagination={false}
      />
    </TableProductSelectedStyles>
  );
};

export default OrderSelected;

export const TableProductSelectedStyles = styled.div`
  .ant-table-thead th {
    text-align: center;
    background: ${({ theme }) => theme?.background?.headerFormTable} !important;
  }

  .ant-table-row > .ant-table-cell:first-child {
    padding-left: 0;
  }

  .ant-table-row > .ant-table-cell:not(:first-child) {
    //  text-align: center;
  }
`;
